import ProfileManage from './ProfileManage';

export default ProfileManage;
